import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import './index.sass';
import { IconButton } from 'components/Button';

const { block, el } = bem('secret-santa-banner');
export const SecretSantaBanner = ({ onClick }) => {
  return (
    <div className={ block() } onClick={onClick}>
      <div className={ el('image') } />
      <div className={ el('content') }>
        <div className={ el('content-wrap') }>
          <div className={ el('content-top') }>
            <div className={ el('title') }>
              <Text serif>{ `Подарочные наборы\nот` } <i>Вероники Сидоровой</i></Text>
            </div>
          </div>
          <div className={ el('content-bottom') }>
            <IconButton name='arrow-right'>В магазин</IconButton>
          </div>
        </div>
      </div>
    </div>
  )
}
